import { getEnv, isTestEnvironment } from "@remi/environment";

import { quietRemiLogger, remiLogger as rl } from "./browser";
import type { RemiLogger } from "./remi-logger";
import { remiLogger as rlServer } from "./server";

let remiLogger: RemiLogger;

// Initialize with browser values by default
remiLogger = rl;

// Check for the server environment
if (typeof window === "undefined" && !isTestEnvironment()) {
  remiLogger = rlServer;
}

// Keyed on VITEST rather than isTestEnvironment(): E2E servers count as a test environment too, and
// are debugged from their info logs. Warnings and errors still print. getEnv throws under jsdom.
if (typeof window === "undefined" && getEnv("VITEST") === "true" && !getEnv("VERBOSE_TEST_LOGGING")) {
  remiLogger = quietRemiLogger;
}

export { flushLogs } from "./server";
export { remiLogger };
